import React from 'react';
import SectionComponent from "./SectionComponent";
import { IMG_FIT_OUT } from "../../data/constructionServiceImages";

function InteriorFitOut() {
  return (
    <SectionComponent
      images={IMG_FIT_OUT}
      titles={{
        mainTitle: "Interior fit-out",
        subTitle: "Finishes, partitions, and second fix",
        sectionTitle1: "Package integration",
        sectionTitle2: "Quality control",
        sectionTitle3: "Protection & completion",
        sectionTitle4: "Project photography",
      }}
      descriptions={{
        sectionDescription1: "We integrate partitions, ceilings, joinery, and finishes so architectural intent is reflected in tolerances, junctions, and material transitions.",
        sectionDescription2: "QC walks are scheduled against agreed benchmarks—lighting, levels, and interfaces—before decorative completion locks in.",
        sectionDescription3: "We protect completed work through the tail of the programme and manage punch lists so handover is orderly and documented.",
        imageAlt: "Interior fit-out and finishes"
      }}
      galleryLink="/projects/fit-out"
      seo={{
        title: "Interior fit-out",
        description: "Interior fit-out, finishes, and quality-focused delivery for design-led projects. MA Renovations."
      }}
    />
  )
}

export default InteriorFitOut;
